/* Homivo — Verzekerd verzenden in de winkelwagen
   -------------------------------------------------
   Werkt via de Shopify cart API, dus onafhankelijk van welke app de
   winkelwagen tekent (hier SlideCart HQ). De verzekering is een echte
   regel in de winkelwagen; SlideCart toont hem daardoor automatisch.

   Twee varianten, geen Shopify-korting nodig:
   - onder de drempel  -> betaalde variant (EUR 2,95)
   - vanaf de drempel  -> gratis variant (EUR 0,00)

   Config komt uit snippets/hv-insure.liquid via window.HV_INSURE.
*/
(function () {
  var C = window.HV_INSURE || {};
  var BETAALD = parseInt(C.variant || 0, 10);
  var GRATIS  = parseInt(C.variantFree || 0, 10);
  var DREMPEL = parseInt(C.freeFrom || 2, 10);

  var DEBUG = location.search.indexOf('hvdebug=1') > -1;
  function log() {
    if (!DEBUG) return;
    var a = ['[hv-insure]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, a);
  }

  if (!BETAALD) {
    log('GESTOPT: geen variant-ID. window.HV_INSURE =', window.HV_INSURE);
    return;
  }
  log('gestart', { betaald: BETAALD, gratis: GRATIS, drempel: DREMPEL });

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var bezig = false;

  /* Standaard AAN. Vinkt de klant zelf uit, dan onthouden we dat voor
     deze sessie, zodat hij niet bij elke aantalwijziging terugkomt.
     Bij een lege winkelwagen wordt de vlag gewist. */
  function uitGezet() {
    try { return sessionStorage.getItem('hv_insure_uit') === '1'; } catch (e) { return false; }
  }
  function zetUit(v) {
    try { v ? sessionStorage.setItem('hv_insure_uit', '1') : sessionStorage.removeItem('hv_insure_uit'); } catch (e) {}
  }
  var laatsteStand = '';

  function isVerzekering(vid) { return vid === BETAALD || (GRATIS && vid === GRATIS); }
  /* Telt mee voor de drempel van de gratis verzekering: betaald en geen SD-kaart (Stijn, 14 okt 2026: "de verzekerde
     verzending moet niet gratis zijn bij de sd kaart"). */
  /* Is de winkelwagenpagina zelf nog bezig met een regel? (dm-cart zet data-busy). Deze functie ontbrak in het live thema:
     hersync() gooide daardoor een ReferenceError (in het testthema al eerder hersteld). */
  function paginaBezig() { return !!document.querySelector('[data-hv-line][data-busy]'); }
  /* Het hoogste aantal stuks van één product (twee kleuren van hetzelfde product tellen samen). Alleen dat bepaalt of de verzekering
     gratis is: 2 stuks van hetzelfde product, niet 2 verschillende producten (Stijn, 14 okt 2026). */
  function zelfdeMax(items) {
    var per = {}, m = 0;
    (items || []).forEach(function (it) {
      if (isVerzekering(it.variant_id) || !telt(it)) return;
      var k = it.product_id || it.variant_id;
      per[k] = (per[k] || 0) + it.quantity;
      if (per[k] > m) m = per[k];
    });
    return m;
  }
  function telt(it) { return it.final_price > 0 && String(it.product_type || '').toLowerCase().trim() !== 'sd kaart'; }

  /* Gedeeld slot met de cart-pagina, zodat er nooit twee /cart-verzoeken
     tegelijk lopen. Zonder slot geeft Shopify 422 en toont de pagina
     "Bijwerken lukte niet". */
  function metSlot(fn) {
    if (typeof window.HV_METSLOT === 'function') return window.HV_METSLOT(fn);
    return Promise.resolve().then(fn);
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function haalCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* Laat de cart-app opnieuw tekenen. Verschillende apps luisteren op
     verschillende signalen, dus we vuren de gangbare af. */
  function ververs(cart) {
    if (cart && typeof window.HVK_PAINT === 'function') {
      try { window.HVK_PAINT(cart); } catch (e) {}
    }
    try {
      if (window.slidecart && typeof window.slidecart.refresh === 'function') window.slidecart.refresh();
      if (window.SLIDECART && typeof window.SLIDECART.refresh === 'function') window.SLIDECART.refresh();
    } catch (e) {}
    eigenEvent = true;
    setTimeout(function () { eigenEvent = false; }, 400);
    ['cart:refresh', 'cart:updated', 'slidecart:refresh'].forEach(function (n) {
      try { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); } catch (e) {}
    });
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hv-insure' });
      }
    } catch (e) {}
  }

  /* Na een wijziging aan de verzekering alleen hertekenen, niet herladen.
     paint() werkt regels, Overzicht, toggle en de header-teller bij.
     Een herlaad is alleen nodig als de winkelwagen leeg raakt, en dat
     regelt de cart-pagina zelf. */
  function naMutatie(cart) {
    ververs(cart);
    hersync();
    log('hertekend zonder herlaad');
  }

  /* Laatste woord: haal de echte winkelwagen op en teken die.
     Draait gedempt na elke wijziging, zodat het scherm nooit een
     mengeling van twee toestanden kan blijven tonen. */
  function hersync() {
    clearTimeout(window.__hvSync);
    window.__hvSync = setTimeout(function () {
      if (bezig || paginaBezig()) { hersync(); return; }
      haalCart().then(function (c) {
        if (!c || !Array.isArray(c.items)) return;
        var betaald = 0, huidig = 0;
        c.items.forEach(function (it) {
          if (isVerzekering(it.variant_id)) huidig = it.variant_id;
          else if (it.final_price > 0) betaald += it.quantity;
        });
        if (typeof window.HVK_PAINT === 'function') {
          try { window.HVK_PAINT(c); } catch (e) {}
        }
        var zelfde = zelfdeMax(c.items);
        teken(zelfde, huidig);
        log('hersync: betaald=' + betaald + ' zelfde=' + zelfde + ' huidig=' + huidig);
      }).catch(function () {});
    }, 500);
  }

  /* ---------- De beslissing ---------- */
  var eigenEvent = false;   // negeer de events die we zelf afvuren

  function beoordeel(cart) {
    if (bezig) return;
    var klaar = cart ? Promise.resolve(cart) : haalCart();

    klaar.then(function (c) {
      if (!c || !c.items) return;
      log('cart:', c.item_count, 'regels');

      var betaald = 0, huidig = 0, huidigKey = null, huidigAantal = 0;
      c.items.forEach(function (it) {
        if (isVerzekering(it.variant_id)) {
          huidig = it.variant_id;
          huidigKey = it.key;
          huidigAantal = it.quantity;
        } else if (it.final_price > 0) {
          betaald += it.quantity;
        }
      });

      var zelfde = zelfdeMax(c.items);
      var doel = (GRATIS && zelfde >= DREMPEL) ? GRATIS : BETAALD;
      log('betaald=' + betaald, 'huidig=' + huidig, 'doel=' + doel);

      /* Zelfde stand niet twee keer behandelen */
      var stand = betaald + '|' + zelfde + '|' + huidig + '|' + huidigAantal + '|' + uitGezet();
      if (stand === laatsteStand) { teken(zelfde, huidig); return; }
      laatsteStand = stand;

      /* 1. Niets betaalds meer -> verzekering eruit */
      if (betaald === 0 && huidig) {
        bezig = true;
        zetUit(false);
        metSlot(function () {
          return post(root + 'cart/change.js', { id: huidigKey || String(huidig), quantity: 0 });
        })
          .then(function (n) { bezig = false; laatsteStand = ''; teken(0, 0); naMutatie(n); })
          .catch(function () { bezig = false; });
        return;
      }

      /* 2. Nog geen verzekering -> toevoegen */
      if (betaald > 0 && !huidig && !uitGezet()) {
        bezig = true;
        metSlot(function () {
          return post(root + 'cart/add.js', { id: String(doel), quantity: 1 })
            .then(function () { return haalCart(); });
        })
          .then(function (n) {
            bezig = false; laatsteStand = ''; teken(zelfde, doel); naMutatie(n);
            /* het cadeau-script kan tegelijk toevoegen: daarna nog een keer kijken of het er echt één is */
            setTimeout(function () { beoordeel(); }, 900);
          })
          .catch(function () { bezig = false; });
        return;
      }

      /* 3. Verkeerde variant -> wisselen */
      if (huidig && huidig !== doel) {
        bezig = true;
        metSlot(function () {
          return post(root + 'cart/change.js', { id: huidigKey || String(huidig), quantity: 0 })
            .then(function (na) {
              /* alleen toevoegen als het verwijderen echt gelukt is,
                 anders staan er straks twee verzekeringsregels */
              var weg = true;
              ((na && na.items) || []).forEach(function (it) {
                if (isVerzekering(it.variant_id)) weg = false;
              });
              if (!weg) throw new Error('verwijderen mislukt');
              return post(root + 'cart/add.js', { id: String(doel), quantity: 1 });
            })
            .then(function () { return haalCart(); });
        })
          .then(function (n) { bezig = false; laatsteStand = ''; teken(zelfde, doel); naMutatie(n); })
          .catch(function () {
            bezig = false; laatsteStand = '';
            log('wissel mislukt, nog een poging');
            setTimeout(function () { beoordeel(); }, 800);
          });
        return;
      }

      /* 4. Altijd precies één verzekering (Stijn, 30 okt 2026): twee scripts kunnen tegelijk toevoegen, en dan betaalt de klant dubbel */
      if (huidig && huidigAantal > 1) {
        bezig = true;
        metSlot(function () {
          return post(root + 'cart/change.js', { id: huidigKey || String(huidig), quantity: 1 });
        })
          .then(function (n) { bezig = false; laatsteStand = ''; teken(zelfde, huidig); naMutatie(n); })
          .catch(function () { bezig = false; laatsteStand = ''; });
        return;
      }

      teken(zelfde, huidig);
    }).catch(function () {});
  }

  /* ---------- Productregel verbergen in de winkelwagen ---------- */
  function verbergRegel() {
    var titel = (C.titel || 'Verzekerd verzenden').toLowerCase();
    var ids = [String(BETAALD), String(GRATIS)];

    var kandidaten = document.querySelectorAll(
      '#slidecarthq .item, #slidecarthq [class*="line-item"], ' +
      '.cart-item, tr.cart-item, .cart__items .cart-item'
    );

    Array.prototype.forEach.call(kandidaten, function (rij) {
      if (rij.getAttribute('data-hv-verborgen')) return;

      var raak = false;

      /* 1. via variant-id in een link */
      var links = rij.querySelectorAll('a[href]');
      Array.prototype.forEach.call(links, function (a) {
        var h = a.getAttribute('href') || '';
        ids.forEach(function (id) { if (id !== '0' && h.indexOf(id) > -1) raak = true; });
      });

      /* 2. via data-attributen */
      if (!raak) {
        ids.forEach(function (id) {
          if (id !== '0' && (rij.getAttribute('data-variant-id') === id ||
                             rij.getAttribute('data-id') === id ||
                             rij.getAttribute('data-key') === id)) raak = true;
        });
      }

      /* 3. via data-variant op de regel (cart-pagina) */
      if (!raak) {
        ids.forEach(function (id) {
          if (id !== '0' && rij.getAttribute('data-variant') === id) raak = true;
        });
      }

      if (raak) {
        rij.setAttribute('data-hv-verborgen', '1');
        rij.style.setProperty('display', 'none', 'important');
      }
    });
  }

  /* ---------- Toggle in de lade ---------- */
  function vindLade() {
    return document.getElementById('slidecarthq') ||
           document.querySelector('[id*="slidecart"],[class*="slidecart"]') ||
           document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
  }

  function vindPlek(lade) {
    if (!lade) return null;
    var kandidaten = [
      '.footer', '[class*="footer"]',
      '.subtotal', '[class*="subtotal"]',
      '[class*="checkout"]'
    ];
    for (var i = 0; i < kandidaten.length; i++) {
      var el = lade.querySelector(kandidaten[i]);
      if (el) return el;
    }
    return lade;
  }

  function teken(betaald, huidig) {
    var aan = !!huidig;
    /* Het label volgt het AANTAL artikelen, net als de server-render.
       Welke variant er op dit moment ligt kan een tel achterlopen als
       de wissel nog loopt; de klant hoort meteen te zien wat hij krijgt. */
    var gratis = GRATIS && betaald >= DREMPEL;
    var rij = document.querySelector('[data-hv-insure]');

    /* Staat de rij er al (server-gerenderd op de winkelwagenpagina),
       dan alleen bijwerken. Een cart-lade is daar niet voor nodig. */
    if (!rij) {
      var lade = vindLade();
      if (!lade) { log('geen rij en geen lade'); return; }
      var plek = vindPlek(lade);
      rij = document.createElement('div');
      rij.className = 'footer-row hv-insure';
      rij.setAttribute('data-hv-insure', '1');
      rij.setAttribute('role', 'button');
      rij.setAttribute('tabindex', '0');
      plek.insertBefore(rij, plek.firstChild);
      log('toggle geplaatst in', plek.className || plek.tagName);
    }

    rij.classList.toggle('is-on', aan);
    rij.innerHTML =
      '<div class="hv-insure__icon"><svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M12 2l8 3v6c0 5-3.5 9.5-8 11-4.5-1.5-8-6-8-11V5l8-3z"/><path d="M9 12l2 2 4-4"/></svg></div>' +
      '<div class="hv-insure__info">' +
        '<div class="hv-insure__title"><span>' + (C.titel || 'Verzekerd verzenden') + '</span>' +
          (gratis
            ? '<span class="hv-insure__gratis">Gratis <s>' + (C.prijs || '+&euro;2,95') + '</s></span>'
            : '<span class="hv-insure__prijs">' + (C.prijs || '+&euro;2,95') + '</span>') +
        '</div>' +
        (C.sub ? '<div class="hv-insure__sub">' + C.sub + '</div>' : '') +
      '</div>' +
      '<div class="hv-insure__check"><svg viewBox="0 0 24 24" aria-hidden="true">' +
        '<path d="M5 12l5 5L20 6"/></svg></div>';

    verbergRegel();
  }

  function schakel() {
    if (bezig) return;
    var rij = document.querySelector('[data-hv-insure]');
    if (!rij) return;

    if (rij.classList.contains('is-on')) {
      haalCart().then(function (c) {
        var it = (c.items || []).filter(function (x) { return isVerzekering(x.variant_id); })[0];
        if (!it) return;
        bezig = true;
        zetUit(true);
        rij.classList.remove('is-on');
        metSlot(function () {
          return post(root + 'cart/change.js', { id: it.key, quantity: 0 })
            .then(function () { return haalCart(); });
        })
          .then(function (n) { bezig = false; laatsteStand = ''; naMutatie(n); })
          .catch(function () { bezig = false; });
      });
    } else {
      zetUit(false);
      laatsteStand = '';
      beoordeel();
    }
  }

  /* De cart-pagina roept dit aan vlak voor een reload, zodat de
     verzekering niet als enige regel achterblijft. */
  window.HV_INSURE_OPRUIMEN = function () {
    return haalCart().then(function (c) {
      var it = (c.items || []).filter(function (x) { return isVerzekering(x.variant_id); })[0];
      if (!it) return;
      zetUit(false);
      return metSlot(function () {
        return post(root + 'cart/change.js', { id: it.key, quantity: 0 });
      });
    }).catch(function () {});
  };

  /* ---------- Klik overal opvangen, ook server-gerenderd ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-hv-insure]')) { e.preventDefault(); schakel(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (e.target.closest && e.target.closest('[data-hv-insure]')) { e.preventDefault(); schakel(); }
  });

  /* ---------- Aanhaken zonder de bestaande callback te slopen ---------- */
  var vorige = window.SLIDECART_UPDATED;
  window.SLIDECART_UPDATED = function (cart) {
    var uit;
    if (typeof vorige === 'function') { try { uit = vorige(cart); } catch (e) {} }
    setTimeout(function () { beoordeel(cart); }, 80);
    return uit;
  };

  /* Vangnet: reageren zodra de lade verschijnt of verandert */
  var laatsteLade = null;
  function kijk() {
    var lade = vindLade();
    if (!lade || lade === laatsteLade || !window.MutationObserver) return;
    laatsteLade = lade;
    log('observer op lade gezet');
    new MutationObserver(function () {
      verbergRegel();
      if (bezig) return;
      clearTimeout(window.__hvInsTimer);
      window.__hvInsTimer = setTimeout(function () { beoordeel(); }, 400);
    }).observe(lade, { childList: true, subtree: true });
    beoordeel();
  }

  function start() {
    log('start; lade aanwezig?', !!vindLade());
    kijk();
    verbergRegel();
    beoordeel();

    /* de cart-pagina meldt zelf wijzigingen */
    document.addEventListener('cart:refresh', function () {
      hersync();                       // altijd, ook bij eigen events
      if (eigenEvent) { log('eigen event, overgeslagen'); return; }
      laatsteStand = '';
      setTimeout(function () { beoordeel(); }, 250);
    });

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
